<template>
  <v-app>
    <router-view v-if="!isMobile" />
    <router-view v-else name="mobile" />
  </v-app>
</template>

<script>
export default {
  name: "App",
  computed: {},

  watch: {},

  data: () => ({
    isMobile: false,
  }),

  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },

  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 800;
    },
  },

  components: {},
};
</script>
